import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Snackbar } from '@mui/material';

import { clearChunkReloadAttempt } from '../../../bootstrap/chunkErrorRecovery';
import useAppVersionCheck from './useAppVersionCheck';

const AppVersionBanner = () => {
  const { isLatestVersion, emptyCacheStorage } = useAppVersionCheck();

  useEffect(() => {
    if (isLatestVersion) {
      clearChunkReloadAttempt();
    }
  }, [isLatestVersion]);

  return (
    <Snackbar
      open={!isLatestVersion}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: (theme) => theme.zIndex.snackbar + 100 }}
    >
      <Alert
        severity="info"
        sx={{ width: '100%', alignItems: 'center' }}
        action={(
          <Button color="inherit" size="small" onClick={emptyCacheStorage}>
            Atualizar agora
          </Button>
        )}
      >
        Nova versão disponível. Atualize para continuar com as últimas correções.
      </Alert>
    </Snackbar>
  );
};

const AppVersionGuard = ({ children }) => (
  <>
    <AppVersionBanner />
    {children}
  </>
);

AppVersionGuard.propTypes = {
  children: PropTypes.node,
};

export default AppVersionGuard;
